import {email, subject} from "../urls"

const EmailText = () => {
    return(
        <a href={`mailto:${email}?subject=${encodeURIComponent(subject) || ''}`} >
            {email}
        </a>
    )
}
export default EmailText